import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Accueil from './pages/Accueil';
import Profile from './pages/Profile';
import Connexion from './pages/Connexion';
import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import Login from './components/Login';
import SignUp from './components/Signup';
import Facturation from './components/Facturation';
import Vendre from './pages/Vendre';
import Panier from './components/Panier';
import PaymentMethod from './components/PaymentMethod';
import Success from './components/Success'; // Importez le composant
import AdminApp from './Admin/App'; // Fichier App.js pour l'admin
import PowerBIReport from'./pages/PowerBiReport';
import AdminDashboard from'./pages/AdminDashboard';
import Dashboard from'./pages/Dashboard';


import { ToastContainer } from 'react-bootstrap';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    };

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  useDocTitle("MarketPlace");

  return (
    <>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accueil" element={<Accueil />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/connexion" element={<Connexion />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/facturation" element={<Facturation />} />
            <Route path="/vendre" element={<Vendre />} />
            <Route path="/CartComponent" element={<Panier />} />
            <Route path="/paymentMethod" element={<PaymentMethod />} />
            <Route path="/success" element={<Success />} />
            {/* Route pour l'application admin */}
            <Route path="/admin/*" element={<AdminApp />} />

            <Route path="/powerbi" element={<PowerBIReport />} />
            <Route path="/admindashboard" element={<AdminDashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />


          </Routes>
          <ToastContainer />
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
